import { render, staticRenderFns } from "./StatsAndParams.vue?vue&type=template&id=f70509ba&scoped=true&"
import script from "./StatsAndParams.vue?vue&type=script&lang=js&"
export * from "./StatsAndParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70509ba",
  null
  
)

export default component.exports